import { User } from './types/User.type';
import AuthService from './services/auth.service';
import { LoginUserModel } from './types/LoginUserModel.type';

interface LocalUser {
  id: string;
  token: string;
  refreshToken: string;
  user?: User;
}

const authTokenKey = 'lhph_user_token';
const authRefreshTokenKey = 'lhph_user_refresh_token';
const userIdKey = 'lhph_user_id';

export function setLocalUser(user: LocalUser): void {
  if (typeof window === 'undefined' || typeof window.localStorage === 'undefined') {
    return;
  }
  window.localStorage.setItem(authTokenKey, user.token);
  window.localStorage.setItem(authRefreshTokenKey, user.refreshToken);
  window.localStorage.setItem(userIdKey, user.id);
}

export function removeLocalUser(): void {
  if (typeof window === 'undefined' || typeof window.localStorage === 'undefined') {
    return;
  }
  window.localStorage.removeItem('user');
  window.localStorage.removeItem(authTokenKey);
  window.localStorage.removeItem(authRefreshTokenKey);
  window.localStorage.removeItem(userIdKey);
}

export function getLocalUser(): LocalUser | null {
  // Guard against localStorage access in non-browser environments
  if (typeof window === 'undefined' || typeof window.localStorage === 'undefined') {
    return null;
  }

  // const token = window.localStorage.getItem(authTokenKey);
  // const refreshToken = window.localStorage.getItem(authRefreshTokenKey);
  // const id = window.localStorage.getItem(userIdKey);

  const userAsString = window.localStorage.getItem('user');
  const user = userAsString ? JSON.parse(userAsString) : null;

  const token = user?.accessToken;
  const refreshToken = user?.refreshToken;
  const id = user?.id;

  //  // console.log('@@@ getLocalUser', token, refreshToken, id, user);
  // if (user) {
  //     return {
  //         token,
  //         refreshToken: refreshToken || '',
  //         id,
  //         user: JSON.parse(user),
  //     };
  // }

  if (token && id && user) {
    return {
      token,
      refreshToken: refreshToken || '',
      id,
    };
  }
  return null;
}

export function getCurrentUser(): Promise<User | null> {
  const user = getLocalUser();

  // console.log('@@@ getCurrentUser', user, );
  if (user) {
    return AuthService.fetchCurrentUser();
  }
  return Promise.resolve(null);
}

export interface AuthUser {
  id: string;
}

export function login({ userIdentifier, password }: LoginUserModel): Promise<AuthUser> {
  return AuthService.login({ userIdentifier, password }).then(res => {
    //  // console.log('@@@ login res', res);
    // const id = String(userId);
    // setLocalUser({token, refreshToken, id});
    return res;
  });
}

export function logout(): Promise<boolean> {
  removeLocalUser();
  return Promise.resolve(true);
}
